import api from './api'
import EndPoint from './endpoints'

export const fetchFileUrls = async (fileList) => {
  if (!Array.isArray(fileList) || fileList.length === 0) return [];
  return new Promise((resolve, reject) => {
    api.postApiCall(
      EndPoint.vendorEndpoints.getFileApi,
      { file_list: fileList },
      (res) => {
        const out = res?.data?.file_urls || [];
        resolve(out);
      },
      (err) => reject(err)
    );
  });
};

export const fetchFileUrlMap = async (fileList) => {
  const list = await fetchFileUrls(fileList);
  const map = {};
  list.forEach((item) => {
    if (item?.filename) map[item.filename] = item.url || null;
  });
  return map;
};

export const fetchFileUrlByPath = async (path) => {
  if (!path) return null;
  const list = await fetchFileUrls([path]);

  const first = Array.isArray(list) ? list[0] : null;
  return first?.url || null;
};
export const getThumbPathsFromMessages = (messages, knownThumbs) => {
  if (!Array.isArray(messages)) return [];
  let thumbPaths = messages
    .filter(msg => Array.isArray(msg.data?.attachments))
    .flatMap(msg => msg.data.attachments.filter(att => att.thumb_path).map(att => att.thumb_path));
  if (knownThumbs) {
    thumbPaths = thumbPaths.filter(tp => !knownThumbs.has(tp));
  }
  return thumbPaths;
}
export default {
  fetchFileUrls,
  fetchFileUrlMap,
  fetchFileUrlByPath,
getThumbPathsFromMessages
};
